import React, { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import completedImage from "../../assests/images/Completed.png";
import purchaseImage from "../../assests/images/Purchase.png";
import pendingImage from "../../assests/images/Pending.png";
import shippedImage from "../../assests/images/Shipped.png";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import checkImage from "../../assests/images/check-circle.png";
import Drawer from "@mui/material/Drawer";
import { UserObj } from "../../services/localStarage";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import { qcServices } from "../../services/qcServices";
import { getSecPermission, isEmptyDash, strToDate,trimString } from "../../constant";
import Tooltip from '@mui/material/Tooltip';

import _ from "lodash";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import Filter from "../filter/filter";
import { commonServices } from "../../services/commonServices";
import { downloadFile } from "../buyerPurchaseOrder";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import TrackOrder from "../common/trackOrder";

const initialColumns = [
  { id: "qcNumber", title: "QC Number", dataIndex: "qcNumber", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "vendorName", title: "Vendor Name", dataIndex: "vendorname", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "buyerName", title: "Buyer Name", dataIndex: "buyername", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "poNumber", title: "PO Number", dataIndex: "ponumber", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "mdccNumber", title: "MDCC Number", dataIndex: "mdccnumber", isSort: true, sortLabel: "", formate: "TEXT"  },
  
  // { id: "createdBy", title: "Created By", dataIndex: "createdBy", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "createdAt", title: "Created On", dataIndex: "createdAt", isSort: true, sortLabel: "", formate: "DATE" },
  { id: "updatedAt", title: "Updated On", dataIndex: "updatedAt", isSort: true, sortLabel: "", formate: "DATE" },

  { id: "poQty", title: "Po Quantity", dataIndex: "poquantity  ", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "qcQty", title: "QC Quantity", dataIndex: "qcquantity", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "dateOfInspection", title: "Date of Inspection", dataIndex: "dateofinspection", isSort: true, sortLabel: "", formate: "DATE"  },
];

const initialData = [
  {
    id: "1",
    qcNumber: (
      <Link
        style={{ color: "blue", textDecoration: "none" }}
        to="/admin/qc-detail"
      >
        00701
      </Link>
    ),
    vendorname: "Apex Supplies Co.",
    buyername: "Suntech Solutions",
    ponumber: "00731",
    mdccnumber: "4600",
    poquantity: "5626",
    qcquantity: "3933",
    dateofinspection: "14-01-2024",
  },
  {
    id: "2",
    qcNumber: "00702",
    vendorname: "Global Trade Solutions",
    buyername: "WindFlow Inc.",
    ponumber: "00732",
    mdccnumber: "6690",
    poquantity: "9374",
    qcquantity: "8861",
    dateofinspection: "16-01-2024",
  },
  {
    id: "3",
    qcNumber: "00703",
    vendorname: "Vertex Procurement",
    buyername: "HydroPower Tech",
    ponumber: "00733",
    mdccnumber: "5948",
    poquantity: "1439",
    qcquantity: "4152",
    dateofinspection: "19-01-2024",
  },
  {
    id: "4",
    qcNumber: "00704",
    vendorname: "Prime Vendors Inc.",
    buyername: "EcoMaterials Ltd.",
    ponumber: "00734",
    mdccnumber: "8861",
    poquantity: "7791",
    qcquantity: "9359",
    dateofinspection: "24-01-2024",
  },
  {
    id: "5",
    qcNumber: "00705",
    vendorname: "Skyline Distributors",
    buyername: "WindFlow Inc.",
    ponumber: "00735",
    mdccnumber: "9261",
    poquantity: "9151",
    qcquantity: "3536",
    dateofinspection: "30-01-2024",
  },
  {
    id: "6",
    qcNumber: "00706",
    vendorname: "RapidSource Ltd.",
    buyername: "WindFlow Inc.",
    ponumber: "00736",
    mdccnumber: "9462",
    poquantity: "9359",
    qcquantity: "4846",
    dateofinspection: "16-01-2024",
  },
  // Additional rows...
];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const approveqcstyle1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const permissionInit = {
  create: false,
  read: false,
  update: false,
  delete: false,
};

function QcListing() {
  // const [openreqcmodalremarks, setOpenReQcModalRemarks ] = useState(false);
  // const [openapproveqcmodalremarks, setOpenApproveQcModalRemarks ] = useState(false);
  // const [openrejectedModal, setOpenRejectedModal] = useState(false);
  // const [openrejectedsucessfullyModal, setOpenRejectedSuccessfullyModal] =
  //   useState(false);
  //   const [approveChecklistTabs,setApproveChecklistTabs] = useState("0")
  // const [openapprovepurchasetModal, setOpenApprovePurchaseModal] =
  // useState(false);
  const [opencreateqcmodalcreation, setOpenCreateQcModalCreation] =
    useState(false);
  // const [openapprovesucessfullyModal, setOpenApproveSucessfullyModal] =
  //   useState(false);
  //   const [openextendvalidityremarksmodal, setOpenExtendValidityRemarksModal] =
  //   useState(false);

  const [confirmObj, setConfirmObj] = useState({});

  const [openheaderlevelexcelmodal, setOpenHeaderLevelExcelModal] =
    useState(false);
  const [openheaderlevelsucessfullymodal, setOpenHeaderLevelSucessfullyModal] =
    useState(false);
  // const [openheaderlevelrejectedmodal, setOpenHeaderLevelRejectedModal] =
  //   useState(false);
  // const [openlineitemlevelexcelmodal, setOpenLineItemLevelExcelModal] =
  //   useState(false);
  // const [openlineitemlevelsuccessmodal, setOpenLineItemLevelSuccessModal] =
  //   useState(false);
  // const [openlineitemlevelrejectedmodal, setOpenLineItemLevelRejectedModal] =
  //   useState(false);
  // const [openrelaseesignmodals, setopenRelaseESignModals] = useState(false);
  // const [openrelaseesignsuccessmodals, setopenRelaseESignSuccessModals] =
  //   useState(false);
  // const [openrelaseesignrejectedmodals, setopenRelaseESignRejectedModals] =
  //   useState(false);
  // const [openpopdfpurchasemodal, setOpenPoPdfPurchaseModal] = useState(false);
  // const [openpopdfpurchasesuccessmodal, setOpenPoPdfPurchaseSuccessModal] =
  //   useState(false);
  // const [openpopdfpurchaserejectedmodal, setOpenPoPdfPurchaseRejectedModal] =
  //   useState(false);
  const userRole = UserObj ? UserObj?.role?.name : "";
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [downloadEl, setdownloadEl] = React.useState(null);
  // const [openasnlisthold, setOpenAsnListHold] = useState(false);
  // const [openasnlistholdsuccessfully, setOpenAsnListHoldSuccessfully] =
  //   useState(false);
  // const [opencancelqclisting, setOpenCancelQcListing] = useState(false);
  // const [opencancelqclistingsuccessfully, setOpenCancelQcListingSuccessfully] = useState(false);
  // const qcListing = {
  //   currentPage: 1,
  //   totalPages : 20,
  // }
  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const [isLoading, setIsLoading] = useState(false);
  const [qcListing, setQCListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    qualityChecks: [],
  });

  const [polisting, setPOListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    purchaseOrders: [],
  });
  const [summary, setSummary] = React.useState({});

  const [inputPage, setInputPage] = useState(qcListing?.currentPage || 1);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [requestPayloadPO, setRequestPayloadPO] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [selectedPOArr, setSelectedPOArr] = useState([]);
    const [selectedPOJsonArr, setSelectedPOJsonArr] = useState([]);
  const [filterFormData, setFilterFormData] = useState("");
  const [selectedPO, setselectedPO] = useState("");
  const [trackOrderData, setTrackOrderData] = useState("");
  const [secQCPermission, setSecQCPermission] = useState({
    "QC_LISTING": permissionInit,
    "QC_DETAIL": permissionInit,
    "CREATE_QC": permissionInit,
    "TRACK_ORDER_QC": permissionInit,
    "EDIT_QC": permissionInit,
    "DOWNLOAD_QC": permissionInit,
  });

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };
  const [columns, setColumns] = useState(initialColumns);
  const [data] = useState(initialData);
  const [selectQCId, setSelectedQCId] = useState(false);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const newColumns = Array.from(columns);
    const [moved] = newColumns.splice(result.source.index, 1);
    newColumns.splice(result.destination.index, 0, moved);

    setColumns(newColumns);
  };
  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };
  const [state, dispatch] = React.useReducer(reducer, { open: false });
  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };
  // const onSortChange = (index, sortBy, sortOrder) => {
  //   let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
  // }

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= qcListing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(qcListing?.currentPage);
      }
    }
  };

  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };

  useEffect(() => {
    getQCListing(requestPayload, filterText, filterFormData);
  }, [requestPayload]);

  useEffect(() => {
    getPOListing(requestPayloadPO, filterText, filterFormData);
  }, [requestPayloadPO]);

  useEffect(() => {
    let secQCPermissionInit = _.cloneDeep(secQCPermission);
    let obj = {};
    for (let key in secQCPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecQCPermission(obj);
    getSummary("?uniqueName=QUALITY_CHECK");
  }, []);

  const getSummary = (param) => {
    setIsLoading(true);
    let promise = commonServices.getSummary(param);
    promise.then((res) => {
      if (res.data.success === true) {
        setSummary(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getQCListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }

    let promise = qcServices.getQCListing(param);
    promise.then((res) => {
      if (res.data.success === true) {
        setQCListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };


  const redirectToDetails = (redirectId) => {
    const UserObjInit = JSON.parse(sessionStorage.getItem('user'));
    let param = {
      requestPayload: requestPayload,
      filterText: filterText,
      filterFormData: filterFormData,
      componentName: "QC_LIST",
    };
    UserObjInit["prevLocationData"] = param;
    sessionStorage.setItem("user", JSON.stringify(UserObjInit));
    navigateUrl(`/admin/qc-detail/${redirectId}`);
  };

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getQCListing(requestPayload, filterText);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
    }, 800),
    []
  );

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }
  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }

  const handleFilterFormSubmit = (formDataa) => {
    setFilterFormData(formDataa);
    const updatedPayload = {
      ...requestPayload,
      searchCriteria: formDataa,
    };
    setRequestPayload(updatedPayload);
    getQCListing(updatedPayload, filterText, formDataa || '');
  };

  const handleResetFormSubmit = () => {
    setFilterFormData(null);
    getQCListing(requestPayload, filterText, {});
  }

  const onQCCheckChange = (value, row, rowIndex) => {
    let qcListingInit = _.cloneDeep(qcListing);
    qcListingInit.qualityChecks[rowIndex].isChecked = value;
    let arr = [];
    let jsonArr = [];
    let purchaseOrderID = [];
    for (let i = 0; i < qcListingInit.qualityChecks.length; i++) {
      if (qcListingInit.qualityChecks[i].isChecked == true) {
        arr.push(qcListingInit.qualityChecks[i]._id);
        jsonArr.push(qcListingInit.qualityChecks[i]);
        purchaseOrderID.push(qcListingInit.qualityChecks[i].purchaseOrderId);
      }
    }
    setSelectedPOArr(arr);
    setSelectedPOJsonArr(jsonArr);
    setQCListing(qcListingInit);
    setSelectedQCId(purchaseOrderID);
  }

  const openConfirmModal = (param) => {
    // if (selectedPOArr.length < 1) {
    //   setAlertComponent({ open: true, type: "error", message: `Please select atleast one Purchase Order. ` });
    //   return;
    // }
    let obj = {};
    obj["id"] = param;
    if (param == "header") {
      obj["text"] = "Header Level Excel";
    }
    if (param == "line-item") {
      obj["text"] = "Line Item Level Excel";
    }
    if (param == "mdcc") {
      obj["text"] = "MDCC";
    }
    if (param == "pdf") {
      obj["text"] = "PDF";
    }
    setConfirmObj(obj);
    setOpenHeaderLevelExcelModal(true);
  }

  const closeConfirmModal = (param) => {
    setConfirmObj({});
    setOpenHeaderLevelExcelModal(false);
  }

  const downloadPO = () => {
    setIsLoading(true);
    let bodyData = {
      // "qcIds": selectedPOArr,
      "type": confirmObj?.id, // "line-item", header, mdcc
      ...filterFormData
    };

    if (!isEmptyDash(filterText)) {
      bodyData["search"] = filterText;
    }

    let fileName = "";
    
    // if (selectedPOArr.length > 1) {        
    //   if (confirmObj?.id == "header") {
    //     fileName = "QC_Header_Level_Excel.zip";
    //   }
    //   if (confirmObj?.id == "line-item") {
    //     fileName = "QC_Line_Item_Level_Excel.zip";
    //   }
    //   if (confirmObj?.id == "mdcc") {
    //     fileName = "QC_MDCC.zip";
    //   }
    //   if (confirmObj?.id == "pdf") {
    //     fileName = "QC_PDF_DOC.zip";
    //   }
    // } else {
    //     if (confirmObj?.id == "header") {
    //       fileName = `${selectedPOJsonArr[0]?.qcNumber}_HerderLevelExcel.xlsx`;
    //     }
    //     if (confirmObj?.id == "line-item") {
    //       fileName = `${selectedPOJsonArr[0]?.qcNumber}_LineItemExcel.xlsx`;
    //     }
    //     if (confirmObj?.id == "mdcc") {
    //       fileName = `${selectedPOJsonArr[0]?.qcNumber}_MDCC.pdf`;
    //     }
    //     if (confirmObj?.id == "pdf") {
    //       fileName = `${selectedPOJsonArr[0]?.qcNumber}_PDF_DOC.pdf`;
    //     }
    // }
    
    const data = {
      url: `/v1/common/quality-checks/download`,
      bodyData: bodyData,
      method: "POST",
      fileName: fileName
    };
    downloadFile(data)
      .then(response => {
        if (isEmptyDash(response)) {
          setOpenHeaderLevelExcelModal(false);
          setOpenHeaderLevelSucessfullyModal(true);         
        } else {        
          setAlertComponent({ open: true, type: "success", message: `${response?.data?.message}` });          
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
      })
      .finally(() => {
        setIsLoading(false);
        setOpenHeaderLevelExcelModal(false);
      })

  }

  const getPOListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}&entityType=QC`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    // const filteredFormData = formData ? Object.entries(formData)
    //   .filter(([key, value]) => value !== '')
    //   .reduce((acc, [key, value]) => {
    //     acc[key] = value;
    //     return acc;
    //   }, {}) : {};
    // if (filteredFormData && Object.keys(filteredFormData).length > 0) {
    //   Object.entries(filteredFormData).forEach(([key, value]) => {
    //     param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    //   });
    // }

    let promise = purchaseOrderServices.getPendingPOListing(param);
    promise.then((res) => {
      if (res.data.success === true) {
        setPOListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const onPoSelect = (e) => {
    let { name, value } = e.target;
    setselectedPO(value);
  }

  const onCreateQC = (e) => {
    navigateUrl(`/admin/qc-creation-form?poId=${selectedPO}`)
  }

  const handleTrackOrder = () => {
    if (selectedPOArr.length < 1) {
      setAlertComponent({ open: true, type: "error", message: `Please select atleast one QC. ` });
      return;
    }
    setIsLoading(true);
    purchaseOrderServices.getPOTrackOrder(selectQCId)
      .then(response => {
        if (response?.data?.success == true) {
          toggleDrawer(true)();
          setTrackOrderData(response?.data?.data);
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const DrawerList = (
    <TrackOrder steps={trackOrderData} close={() => toggleDrawer(false)()} refresh={() => handleTrackOrder()} />
  );
  // const handleSelectChange = (e) => {
  //   setApproveChecklistTabs(e.target.value);
  // };

  return (
    <>
      <div className="login-forms">
        <div className="text-centers row_purchase_invoice_dragdropcontext_apps_body">
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_main">
                <h5>QC Listing</h5>
              </div>
              <div className="bpdt_po_order_react">
                {/* <button className="create_btn_lr_creations">
                <Link
                  style={{ color: "white", textDecoration: "none" }}
                  to="/admin/vendor-LR-Creation"
                >
                  Create LR
                </Link>
              </button> */}
                {(secQCPermission?.CREATE_QC?.read == true) && <button onClick={setOpenCreateQcModalCreation} class="create_btn_lr_creations">Create QC</button>}
                {/* <div>
          
                <Button
                  className="vendor_btn vendor_maine_contents"
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <LayersIcon />
                  Action
                </Button>
             
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={setOpenAsnListHold}>Hold</MenuItem>
                  <MenuItem onClick={setOpenCancelQcListing}>Cancel</MenuItem>

                  <MenuItem onClick={setOpenExtendValidityRemarksModal}>Extend Validity</MenuItem>
                  
                  <MenuItem onClick={handleClose}>
                    {" "}
                    <Link
                      className="solutions_block_body"
                      style={{ color: "black", textDecoration: "none" }}
                      to="/admin/qc-detail"
                    >
                      Request for QC
                    </Link>
                  </MenuItem>
                  {userRole === "BUYER" ? (
                  <MenuItem onClick={setOpenApprovePurchaseModal}>Approve</MenuItem>
                   ) : null}
                    {userRole === "BUYER" ? (
                  <MenuItem onClick={setOpenRejectedModal}>Rejected</MenuItem>
                  ) : null}
                   {userRole === "BUYER" ? (
                  <MenuItem onClick={setOpenReQcModalRemarks}>Re-QC</MenuItem>
                  ) : null}
                   {userRole === "BUYER" ? (
                  <MenuItem onClick={setOpenApproveQcModalRemarks}>Approve QC</MenuItem>
                  ) : null}
                </Menu>
              </div> */}
                <div>
                  {(secQCPermission?.DOWNLOAD_QC?.read == true) && <Button
                    className="vendor_btn vendor_maine_contents"
                    id="basic-button"
                    aria-controls={download ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={download ? "true" : undefined}
                    onClick={handleClicks}
                  >
                    <FileDownloadIcon />
                    Download
                  </Button>}
                  <Menu
                    id="basic-menu"
                    anchorEl={downloadEl}
                    open={download}
                    onClose={handleCloses}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={() => openConfirmModal("header")}>
                      Header Level Excel
                    </MenuItem>
                    <MenuItem onClick={() => openConfirmModal("line-item")}>
                      Line Item Level Excel
                    </MenuItem>
                    <MenuItem onClick={() => openConfirmModal("mdcc")}>
                      MDCC
                    </MenuItem>
                    <MenuItem onClick={() => openConfirmModal("pdf")}>
                      PDF
                    </MenuItem>
                  </Menu>
                </div>
              </div>
            </div>
            <div className="account_ledger_listing_row1">
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total QC
                    </label>
                    <p className="block_detail_listing">
                      <b>{isEmptyDash(summary?.total) ? 0 : summary?.total}</b>
                    </p>
                  </div>
                 <img className="purchase_images_letscom"
                    src={purchaseImage}
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Pending QC
                    </label>
                    <p className="block_detail_listing">
                      <b>{isEmptyDash(summary?.pending) ? 0 : summary?.pending}</b>
                    </p>
                  </div>
               <img className="purchase_images_letscom"
                    src={pendingImage}
                    alt=""
                  />
                </div>
              </div>
              {/* <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Shipped Order
                    </label>
                    <p className="block_detail_listing">
                      <b>{isEmptyDash(summary?.shipped) ? 0 : summary?.shipped}</b>
                    </p>
                  </div>
           <img className="purchase_images_letscom"
                    src={shippedImage}
                    alt=""
                  />
                </div>
              </div> */}
              {/* <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Completed Order
                    </label>
                    <p className="block_detail_listing">
                      <b>{isEmptyDash(summary?.completed) ? 0 : summary?.completed}</b>
                    </p>
                  </div>
             <img className="purchase_images_letscom"
                    src={completedImage}
                    alt=""
                  />
                </div>
              </div> */}
            </div>
            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"

                      onChange={onFilterTextChange}
                      value={filterText}
                      onKeyPress={onKeyPressHandler}
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="bpdt_po_order_react">
              {(secQCPermission?.TRACK_ORDER_QC?.read == true) && <div>
                  <button className="btn btn-outline-secondary" onClick={handleTrackOrder}>Track Order</button>
                  <Drawer
                    anchor="right"
                    open={state.open}
                    onClose={toggleDrawer(false)}
                    style={{ zIndex: 99999 }}
                  >
                    {DrawerList}
                  </Drawer>
                </div>}
                {/* <div>
                <button className="btn btn-outline-secondary">
                  <span>
                  <FilterAltOutlinedIcon/>
                  </span>
                  Filter
                </button>
              </div> */}
                <div className="row_filterrbtnvendor_box">
                  <div className="lets_filter_vendorlist_body_detail">
                    <FilterAltIcon />
                    <Filter uniqueName={"QUALITY_CHECK"} formSubmitFunction={handleFilterFormSubmit} resetFilter={handleResetFormSubmit} />
                  </div>
                </div>

              </div>
            </div>
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <div style={{ width: "100%", overflow: "hidden" }}
              className="listing_main listing_main_dragdropcontext_body listingmain">
              <table className="dragdropcontext_ondragend_block_row">
                <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                  <Droppable droppableId="droppable" direction="horizontal">
                    {(provided) => (
                      <tr ref={provided.innerRef} {...provided.droppableProps}>
                        <th className="vendor_tabels">
                          {/* <input type="checkbox" /> */}
                        </th>
                        {columns.map((col, index) => (
                          <Draggable
                            key={col.id}
                            draggableId={col.id}
                            index={index}
                          >
                            {(provided) => (
                              <th
                                className="vendor_tabels"

                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {col.title}
                                {(col.isSort == true) && <span onClick={(e) => onSortChange(index, col.id, col.sortLabel)} className="table-sort-ico">
                                  {/* <SwapVertIcon className="swap-sort-ico" /> */}
                                  {(col.sortLabel != "asc") && <img src={topArrow} />}
                                  {(col.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                  {(col.sortLabel != "desc") && <img src={bottomArrow} />}
                                  {(col.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>}
                              </th>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </tr>
                    )}
                  </Droppable>
                </thead>
                <tbody style={{ overflowY: "scroll", width: "200px" }}>
                  {qcListing?.qualityChecks.length < 1 && <>
                    <tr>
                      <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                    </tr>
                  </>}
                  {qcListing?.qualityChecks?.map((row, rowIndex) => (
                    <tr key={rowIndex} className="maine_tr_vendor">
                      <td>
                        <input type="checkbox" checked={row.isChecked} onChange={(e) => onQCCheckChange(e.target.checked, row, rowIndex)} />
                      </td>

                      {columns.map((column, index) => (<>
                        {(column.id == "qcNumber") ? (<td>
                          <p className="list-details-para" onClick={() => redirectToDetails(row?._id)}>
                            {row[column.id]}
                          </p>
                        </td>) : (column.formate == "DATE") ? (<td>
                          <p  >
                            {isEmptyDash(row[column.id]) ? "N/A" : strToDate(row[column.id])}
                          </p>
                        </td>) :
                            <td key={index} >
                            <Tooltip title={row[column.id] || "N/A"}>
                            {trimString(row[column.id], 20 || "N/A")}
                            </Tooltip>
                          </td>
                        }
                      </>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </DragDropContext>
          {qcListing?.qualityChecks.length > 0 && <>
            <div className="lets_pagination_package_listing_react">
            <div className="pagination_select_react_packagelr_detail">
              <select
                className="form-select packagelrlisting from-hs"
                onChange={onPageSizeChange}
                value={requestPayload?.pageSize}
              >
                <option selected="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span className="react_text_showing">
                {` Showing rows ${Number(qcListing?.pageSize) * Number(qcListing?.currentPage - 1) + 1} to ${Number(qcListing?.pageSize) * Number(qcListing?.currentPage - 1) + Number(qcListing?.qualityChecks?.length)} of ${qcListing?.totalItems}`}
              </span>
            </div>
            <Stack spacing={2}>
              <Pagination
                count={qcListing?.totalPages}
                page={qcListing?.currentPage}
                onChange={(event, page) => {
                  setInputPage(page);
                  onPaginationChange(event, page);
                }}
                renderItem={(item) => {
                  if (item.page === qcListing?.currentPage) {
                    return (
                      <input
                        className="form-control"
                        type="text"
                        value={inputPage}
                        onChange={handleInputChange}
                        onKeyDown={handleInputSubmit}
                        style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                      />
                    );
                  }
                  return (
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  );
                }}
              />
            </Stack>
          </div>
          </>}

          {/* Create QC Modal */}
          <Modal
            open={opencreateqcmodalcreation}
            onClose={() => setOpenCreateQcModalCreation(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Create QC</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenCreateQcModalCreation(false)}
                ></button>
              </div>
              <div class="modal-body">
                <div className="required_react_vendor_blockes">
                  <label className="label_react_block_body_asn">
                    Purchase Order Number
                  </label>
                  <span className="required">*</span>
                  <div className="lets_asn_block_body_required_number">
                    <select
                      class="form-select lr_detail_react_div_row1 vendor_lr"
                      aria-label="Default select example"
                      onChange={onPoSelect}
                      value={selectedPO}
                    >
                      <option value={""} disabled>Select</option>

                      {polisting?.purchaseOrders?.map((ele, i) => (
                        <>
                          <option value={ele?._id}>
                            {ele?.poNumber}
                          </option>
                        </>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="create_qc_modal">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      setOpenCreateQcModalCreation(false);
                      // setOpenAsnListHoldSuccessfully(true);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={onCreateQC}
                  >
                    <Link
                      style={{ color: "white", textDecoration: "none" }}
                      to="/admin/qc-creation-form"
                    >Submit</Link>
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          {/* Extend Validity Modal */}

          {/* <Modal
              open={openextendvalidityremarksmodal}
              onClose={() => setOpenExtendValidityRemarksModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box
                sx={extendvaliditystyle1}
                className="modal_react_controlpanel_employees"
              >
                <div className="modal-headeres">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Extend Validity
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenExtendValidityRemarksModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div
                    className="listing_main"
                    style={{
                      overflowY: "scroll",
                      height: "40vh",
                    }}
                  >
                    <table>
                      <thead>
                        <tr>
                          <th
                            colSpan={1}
                            className=" lets_table_blocklist_react_order"
                          >
                            <p>PO No.</p>
                          </th>
                          <th
                            colSpan={2}
                            className=" lets_table_blocklist_react_order"
                          >
                            <p>Current Validity</p>
                          </th>
                          <th
                            colSpan={2}
                            className=" lets_table_blocklist_react_order"
                          >
                            <p>New Validity</p>
                          </th>
                          <th
                            colSpan={1}
                            className=" lets_table_blocklist_react_order"
                          >
                            <div className="remarks_bdbt_div_react_validity">
                              <p>
                                Remarks <span className="error">*</span>{" "}
                              </p>
                              <ContentCopyIcon />
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <thead>
                        <tr>
                          <th className=" lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer"></p>
                          </th>
                          <th className=" lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">From</p>
                          </th>
                          <th className=" lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">To</p>
                          </th>
                          <th className=" lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">From</p>
                          </th>
                          <th className=" lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">To</p>
                          </th>
                          <th className=" lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer"></p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00701
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-01-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00702
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-03-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00703
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-03-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-04-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00704
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-05-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-06-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00705
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-06-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00706
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-07-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-08-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00707
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-04-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-07-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00708
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-08-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-09-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="table_btn_failed_sucess_purchase">
                    <button className="view_success">Discard</button>
                    <button className="view_failed">Save</button>
                  </div>
                </div>
              </Box>
            </Modal> */}
          {/* Vendor QC Hold Modal Vendor ASN */}
          {/* <Modal
            open={openasnlisthold}
            onClose={() => setOpenAsnListHold(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenAsnListHold(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to "<b>Hold</b>" selected QC?
                  <br />
                  QC No. : <b>00701</b> | QC Amount : <b>₹35,600</b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenAsnListHold(false);
                      setOpenAsnListHoldSuccessfully(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => setOpenAsnListHold(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/*  Vendor QC Hold sucessfully Modal  */}
          {/* <Modal
            open={openasnlistholdsuccessfully}
            onClose={() => setOpenAsnListHoldSuccessfully(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenAsnListHoldSuccessfully(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="approvel_btn_successfully">
                    <img src={holdImage} alt="" />
                    <p className="profile_react_block">
                      Selected QC has been "<b>Hold</b>" Successfully
                    </p>
                    <p className="profile_react_blocks">
                      QC No. : <b>00701</b> | QC Amount : <b>₹35,600</b>
                    </p>
                    <button
                      className="view_progresse"
                      onClick={() => setOpenAsnListHoldSuccessfully(false)}
                    >
                      Ok
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal> */}
          {/* Vendor QC Cancel Modal Vendor ASN */}
          {/* <Modal
            open={opencancelqclisting}
            onClose={() => setOpenCancelQcListing(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenCancelQcListing(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to "<b>Cancel</b>" selected QC?
                  <br />
                  QC No. : <b>00701</b> | QC Amount : <b>₹35,600</b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenCancelQcListing(false);
                      setOpenCancelQcListingSuccessfully(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => setOpenCancelQcListing(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/*  Vendor QC Cancel sucessfully Modal  */}
          {/* <Modal
            open={opencancelqclistingsuccessfully}
            onClose={() => setOpenCancelQcListingSuccessfully(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenCancelQcListingSuccessfully(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="approvel_btn_successfully">
                    <img src={rejectImage} alt="" />
                    <p className="profile_react_block">
                      Selected QC has been "<b>Cancel</b>" Successfully
                    </p>
                    <p className="profile_react_blocks">
                      QC No. : <b>00701</b> | QC Amount : <b>₹35,600</b>
                    </p>
                    <button
                      className="view_progresse"
                      onClick={() => setOpenCancelQcListingSuccessfully(false)}
                    >
                      Ok
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal> */}
          {/* Header Level Excel Purchase listing */}

          <Modal
            open={openheaderlevelexcelmodal}
            onClose={closeConfirmModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenHeaderLevelExcelModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_Manager_bidding">
                  Are you sure you want to download
                  <br /> {confirmObj?.text}
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={downloadPO}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={closeConfirmModal}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Header Level Sucessfully Purchase listing */}
          <Modal
            open={openheaderlevelsucessfullymodal}
            onClose={() => setOpenHeaderLevelSucessfullyModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenHeaderLevelSucessfullyModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkImage} alt="" />
                <p class="project_manager_bidding">
                  Selected <b>{confirmObj?.text}</b> has been
                  <br /> successful download
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenHeaderLevelSucessfullyModal(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Header Level Rejected Purchase listing */}
          {/* <Modal
            open={openheaderlevelrejectedmodal}
            onClose={() => setOpenHeaderLevelRejectedModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenHeaderLevelRejectedModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={rejectImage} alt="" />
                <p class="project_manager_bidding">
                  Selected <b>Header Level</b> has been
                  <br /> Rejected download
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenHeaderLevelRejectedModal(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/* Line Item Level Excel Purchase order */}
          {/* <Modal
            open={openlineitemlevelexcelmodal}
            onClose={() => setOpenLineItemLevelExcelModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenLineItemLevelExcelModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to download
                  <br /> Line Item Level Excel
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenLineItemLevelExcelModal(false);
                      setOpenLineItemLevelSuccessModal(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => {
                      setOpenLineItemLevelExcelModal(false);
                      setOpenLineItemLevelRejectedModal(true);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/* Line Item Level Excel Sucessfully  */}
          {/* <Modal
            open={openlineitemlevelsuccessmodal}
            onClose={() => setOpenLineItemLevelSuccessModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenLineItemLevelSuccessModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkImage} alt="" />
                <p class="project_manager_bidding">
                  Selected <b>Line Item </b> has been
                  <br /> successful download
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenLineItemLevelSuccessModal(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/* Line Item Level Excel Rejected Purchase listing */}
          {/* <Modal
            open={openlineitemlevelrejectedmodal}
            onClose={() => setOpenLineItemLevelRejectedModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenLineItemLevelRejectedModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={rejectImage} alt="" />
                <p class="project_manager_bidding">
                  Selected <b>Line Item</b> has been
                  <br /> Rejected download
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenLineItemLevelRejectedModal(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/* PO PDF Modal Buyer Po */}
          {/* <Modal
            open={openpopdfpurchasemodal}
            onClose={() => setOpenPoPdfPurchaseModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to download PO Pdf
                  <br />
                  <b>PO No. : 00701 </b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenPoPdfPurchaseModal(false);
                      setOpenPoPdfPurchaseSuccessModal(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => {
                      setOpenPoPdfPurchaseModal(false);
                      setOpenPoPdfPurchaseRejectedModal(true);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/* PO PDF Successfully Modal Buyer Po */}
          {/* <Modal
            open={openpopdfpurchaserejectedmodal}
            onClose={() => setOpenPoPdfPurchaseRejectedModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseSuccessModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkImage} alt="" />
                <p class="project_manager_bidding">
                  Selected PO has been "<b>PDF Download</b>" Successfully
                  <br />
                  <b>PO No. : 07001 </b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenPoPdfPurchaseSuccessModal(false);
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/* PO PDF Rejected Modal Buyer Po */}
          {/* <Modal
            open={openpopdfpurchaserejectedmodal}
            onClose={() => setOpenPoPdfPurchaseRejectedModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseRejectedModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={rejectImage} alt="" />
                <p class="project_manager_bidding">
                  Selected PO has been "<b>PDF Download</b>" failed
                  <br />
                  <b>PO No. : 07001 </b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenPoPdfPurchaseRejectedModal(false);
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}

          {/* Approve  Modal  */}
          {/* {userRole === "BUYER" ? (
        <Modal
              open={openapprovepurchasetModal}
              onClose={() => setOpenApprovePurchaseModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenApprovePurchaseModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_Manager_bidding">
                    Are you sure you want to "<b>Approve</b>" selected QC
                      No. :<b>00701</b> | QC Amount : <b>₹35,600</b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenApprovePurchaseModal(false);
                        setOpenApproveSucessfullyModal(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => setOpenApprovePurchaseModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
               ) : null} */}
          {/* Approve sucessfully Modal  */}
          {/* {userRole === "BUYER" ? (
            <Modal
              open={openapprovesucessfullyModal}
              onClose={() => setOpenApproveSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenApproveSucessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={checkcircleImage} alt="" /> 
                      <p className="profile_react_block">
                        Selected QC has been "<b>Approved</b>" Successfully
                      </p>
                      <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => setOpenApproveSucessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
            ) : null} */}

          {/* Rejected Modal  */}
          {/* {userRole === "BUYER" ? (
            <Modal
              open={openrejectedModal}
              onClose={() => setOpenRejectedModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenRejectedModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p className="project_Manager_bidding">
                    Are you sure you want to "<b>Reject</b>" selected QC List
                  </p>
                  <p className="profile_react_blocks">
                    Total PO Selected : <b>15 |</b> QC Amount :<b> ₹35,600 </b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenRejectedModal(false);
                        setOpenRejectedSuccessfullyModal(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => setOpenRejectedModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
            ) : null} */}
          {/* Rejected Successfully Modal */}
          {/* {userRole === "BUYER" ? (
            <Modal
              open={openrejectedsucessfullyModal}
              onClose={() => setOpenRejectedSuccessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenRejectedSuccessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={rejectImage} alt="" />
                      <p className="profile_react_block">
                        Selected QC has been "<b>Reject</b>" Successfully
                      </p>
                      <p className="profile_react_blocks">
                        QC No. : <b>07001 | </b>QC Amount :<b> ₹35,600 |</b> QC
                        Qty : <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => setOpenRejectedSuccessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
            ) : null} */}
          {/* RE QC Modal */}
          {/* {userRole === "BUYER" ? (
                      <Modal
              open={openreqcmodalremarks}
              onClose={() => setOpenReQcModalRemarks(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">Re-QC</h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenReQcModalRemarks(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                <div>
                  <label>Remarks</label>
                <input class="form-control form-haswe" type="text" />
                </div>
                <div>
                  <label>Date </label>
                <input class="form-control form-haswe" type="date"  />
                </div>
                <div class="reqc_btns_remarks">
                  <button          onClick={() => setOpenReQcModalRemarks(false)} class="view_failed">Cancel</button>
                  <button          onClick={() => setOpenReQcModalRemarks(false)} class="view_success" >Submit</button>
                  </div>
                  </form>
                </div>
              </Box>
            </Modal>
                      ) : null} */}
          {/* Approve QC Modal */}
          {/* {userRole === "BUYER" ? (
                       <Modal
              open={openapproveqcmodalremarks}
              onClose={() => setOpenApproveQcModalRemarks(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={approveqcstyle1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">Approve QC Checklist</h1>
                  <div className="manufacturing_checklist_react">
                  <select  onChange={handleSelectChange} className="form-select approve_qc_checklist_select"
                  value={approveChecklistTabs}>
                              <option value="0">Manufacturing </option>
                              <option value="1">Retail</option>
                              <option value="2">Energy</option>
                              </select>

                              <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenApproveQcModalRemarks(false)}
                  ></button>
                  </div>
       
             
                </div>
                <div className="modal-body">
                  <form>
                  { approveChecklistTabs === "0" && 
                  <div class="listing_main bdfte_react_checklist_tabs"  >
                    <table>
                      <thead>
                        <tr>
                         <th class="">Checkpoint Title</th>
                         <th class="">Checkpoint Category</th>
                         <th class="">Checkpoint Motive</th>
                         <th class="">Sampling Size</th>
                         <th class="">Number of Samples</th>
                       
                         <th class="">Required Result</th>
                         <th class="">Files</th>
                         <th class="">Status </th>
                         <th class="">Remarks</th>
                         </tr>
                         </thead>
                         <tbody>
                          <tr>
                          <td style={{width: "max-content"}}>Packing Method</td>
                            <td>Export Packing</td>
                            <td>Conformance to Specs</td>
                            <td>1 pc</td>
                            <td>0</td>
                    
                            <td>Compare to client specification if applicable.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Shipping Marks</td>
                            <td>Export Packing</td>
                            <td>Conformance to Specs</td>
                            <td>1 pc</td>
                            <td>0</td>
                            <td>Compare to client specification if applicable.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr> 
                            <tr>
                          <td style={{width: "max-content"}}>Gross Weight</td>
                            <td>Export Packing</td>
                            <td>Conformance to Specs</td>
                            <td>1 pc</td>
                            <td>0</td>
                        
                            <td>Compare to client specification if applicable.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Dimensions</td>
                            <td>Export Packing</td>
                            <td>Conformance to Specs</td>
                            <td>1 pc</td>
                            <td>0</td>
                      
                            <td>Compare to client specification if applicable.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Barcode Scan</td>
                            <td>Export Packing</td>
                            <td>Conformance to Specs</td>
                            <td>Custom</td>
                            <td>0</td>
                     
                            <td>Compare to client specification if applicable.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Carton Details</td>
                            <td>Export Packing</td>
                            <td>Conformance to Specs</td>
                            <td>All samples</td>
                            <td>0</td>
                     
                            <td>Compare to client specification if applicable.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Appearance</td>
                            <td>Product & Unit Packing</td>
                            <td>Conformance to Specs</td>
                            <td>All samples</td>
                            <td>0</td>
                     
                            <td>Compare to client specification if applicable.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Certification Check</td>
                            <td>Product & Unit Packing</td>
                            <td>Conformance to Specs</td>
                            <td>Custom</td>
                            <td>0</td>
                     
                            <td>Report actual finding and compare to client specification if applicable.	</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Color Check</td>
                            <td>Product & Unit Packing</td>
                            <td>Conformance to Specs</td>
                            <td>All samples</td>
                            <td>0</td>
                     
                            <td>Conforms to specifications.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Material Check</td>
                            <td>Product & Unit Packing  </td>
                            <td>Conformance to Specs</td>
                            <td>All samples</td>
                            <td>6</td>
                     
                            <td>Compare to client specification if applicable.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Printing Check</td>
                            <td>Product & Unit Packing</td>
                            <td>Conformance to Specs</td>
                            <td>All samples</td>
                            <td>2</td>
                     
                            <td>Printing conforms to specifications.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Tread Depth</td>
                            <td>Product & Unit Packing</td>
                            <td>Conformance to Specs</td>
                            <td>Custom</td>
                            <td>5</td>
                     
                            <td>Compare to client specification if applicable.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Bead Wire Integrity</td>
                            <td>Product & Unit Packing</td>
                            <td>Conformance to Specs</td>
                            <td>Custom</td>
                            <td>4</td>
                     
                            <td>Conforms to specifications.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Rubber Compound</td>
                            <td>Product & Unit Packing</td>
                            <td>Conformance to Specs</td>
                            <td>Custom</td>
                            <td>10</td>
                     
                            <td>Conforms to specifications.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Barcode Scan</td>
                            <td>Export Packing</td>
                            <td>Conformance to Specs</td>
                            <td>1 pc</td>
                            <td>0</td>
                     
                            <td>Compare to client specification if applicable.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                            <tr>
                          <td style={{width: "max-content"}}>Barcode Scan</td>
                            <td>Export Packing</td>
                            <td>Conformance to Specs</td>
                            <td>1 pc</td>
                            <td>0</td>
                     
                            <td>Compare to client specification if applicable.</td>
                            <td>
                              <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                            </td>
                            <td>
                              <select class="form-select approve_reject_checklist_select1">
                              <option value="selected">Selected</option>
                              <option value="">Approved</option>
                              <option value="">Rejected</option>
                              </select>
                              </td>
                            <td><input type="text" class="form-control from-has_select_checklist "/></td>
                            </tr>
                      
                       
                          </tbody>
                          </table>
                          </div>
                           }
                               { approveChecklistTabs === "1" && 
                  <div class="listing_main bdfte_react_checklist_tabs"  >
                  <table>
                    <thead>
                      <tr>
                       <th class="">Checkpoint Title</th>
                       <th class="">Checkpoint Category</th>
                       <th class="">Checkpoint Motive</th>
                       <th class="">Sampling Size</th>
                       <th class="">Number of Samples</th>
                     
                       <th class="">Required Result</th>
                       <th class="">Files</th>
                       <th class="">Status </th>
                       <th class="">Remarks</th>
                       </tr>
                       </thead>
                       <tbody>
                        <tr>
                        <td style={{width: "max-content"}}>Packing Method</td>
                          <td>Packaging</td>
                          <td>Conformance to Specs</td>
                          <td>1 pc</td>
                          <td>0</td>
                  
                          <td>Compare to client specification if applicable.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Shipping Marks</td>
                          <td>Packaging</td>
                          <td>Conformance to Specs</td>
                          <td>1 pc</td>
                          <td>0</td>
                          <td>Compare to client specification if applicable.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr> 
                          <tr>
                        <td style={{width: "max-content"}}>Gross Weight</td>
                          <td>Packaging</td>
                          <td>Conformance to Specs</td>
                          <td>1 pc</td>
                          <td>0</td>
                      
                          <td>Compare to client specification if applicable.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Barcode Scan</td>
                          <td>Packaging</td>
                          <td>Conformance to Specs</td>
                          <td>1 pc</td>
                          <td>0</td>
                    
                          <td>Compare to client specification if applicable.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Label Details</td>
                          <td>Packaging</td>
                          <td>Conformance to Specs</td>
                          <td>Custom</td>
                          <td>0</td>
                   
                          <td>Report actual findings, compare to client specifications.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Appearance</td>
                          <td>Product Quality</td>
                          <td>Conformance to Specs</td>
                          <td>All samples</td>
                          <td>0</td>
                   
                          <td>Conforms to specifications.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Weight</td>
                          <td>Product & Unit Packing</td>
                          <td>Conformance to Specs</td>
                          <td>All samples</td>
                          <td>0</td>
                   
                          <td>Compare to client specification if applicable.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Material Check</td>
                          <td>Product Quality</td>
                          <td>Conformance to Specs</td>
                          <td>Custom</td>
                          <td>0</td>
                   
                          <td>Conforms to specifications.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Color Check</td>
                          <td>Product Quality</td>
                          <td>Conformance to Specs</td>
                          <td>All samples</td>
                          <td>0</td>
                   
                          <td>Conforms to specifications.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Smell Check</td>
                          <td>Product Quality</td>
                          <td>Aesthetics & Smell</td>
                          <td>All samples</td>
                          <td>6</td>
                   
                          <td>No strong or irritative smell should be found.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Printing Check</td>
                          <td>Product Quality</td>
                          <td>Conformance to Specs</td>
                          <td>All samples</td>
                          <td>2</td>
                   
                          <td>Printing conforms to specifications.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Functionality Testing</td>
                          <td>Functional Testing</td>
                          <td>Performance Check</td>
                          <td>Custom</td>
                          <td>5</td>
                   
                          <td>Must perform according to client specifications.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Safety Testing</td>
                          <td>Functional Testing</td>
                          <td>Safety Compliance</td>
                          <td>Custom</td>
                          <td>4</td>
                   
                          <td>Must meet safety standards and specifications.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Usability Testing</td>
                          <td>Functional Testing</td>
                          <td>User Experience</td>
                          <td>Custom</td>
                          <td>10</td>
                   
                          <td>Must provide satisfactory user experience.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                         
                    
                     
                        </tbody>
                        </table>
                        </div>
                           }
                               { approveChecklistTabs === "2" && 
                  <div class="listing_main bdfte_react_checklist_tabs"  >
                  <table>
                    <thead>
                      <tr>
                       <th class="">Checkpoint Title</th>
                       <th class="">Checkpoint Category</th>
                       <th class="">Checkpoint Motive</th>
                       <th class="">Sampling Size</th>
                       <th class="">Number of Samples</th>
                       <th class="">Required Result</th>
                       <th class="">Files</th>
                       <th class="">Status </th>
                       <th class="">Remarks</th>
                       </tr>
                       </thead>
                       <tbody>
                        <tr>
                        <td style={{width: "max-content"}}>Certification Check</td>
                          <td>Equipment Inspection</td>
                          <td>Compliance</td>
                          <td>Custom</td>
                          <td>5</td>
                  
                          <td>Equipment should be free from any damages or defects.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Calibration Records</td>
                          <td>Equipment Inspection</td>
                          <td>Conformance to Specs</td>
                          <td>Custom</td>
                          <td>10</td>
                          <td>Calibration records should be accurate and up-to-date.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr> 
                          <tr>
                        <td style={{width: "max-content"}}>Material Quality</td>
                          <td>Material Inspection</td>
                          <td>Conformance to Specs</td>
                          <td>Custom</td>
                          <td>0</td>
                      
                          <td>Material should meet specified quality standards.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Safety Features</td>
                          <td>Equipment Inspection</td>
                          <td>Safety Compliance</td>
                          <td>1 pc</td>
                          <td>0</td>
                    
                          <td>Safety features must comply with industry standards.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Spare Parts Availability</td>
                          <td>Packaging</td>
                          <td>Operational Efficiency</td>
                          <td>Custom</td>
                          <td>0</td>
                   
                          <td>Spare parts should be readily available</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Installation Procedure</td>
                          <td>Installation</td>
                          <td>Conformance to Specs</td>
                          <td>All samples</td>
                          <td>0</td>
                   
                          <td>Procedure should conform to manufacturer's</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Electrical Connections</td>
                          <td>Installation</td>
                          <td>Conformance to Specs</td>
                          <td>All samples</td>
                          <td>0</td>
                   
                          <td>Electrical connections must be safe and compliant .</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Mechanical Fixings</td>
                          <td>Installation</td>
                          <td>Conformance to Specs</td>
                          <td>Custom</td>
                          <td>20</td>
                   
                          <td>Mechanical fixings should be secure and accurate.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Functional Testing</td>
                          <td>Commissioning</td>
                          <td>Performance Check</td>
                          <td>Custom</td>
                          <td>0</td>
                   
                          <td>Equipment should perform as per specifications.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Safety Testing</td>
                          <td>Commissioning</td>
                          <td>Safety Compliance</td>
                          <td>Custom</td>
                          <td>6</td>
                   
                          <td>Equipment should pass all safety tests.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Environmental Compliance</td>
                          <td>Commissioning</td>
                          <td>Compliance</td>
                          <td>Custom</td>
                          <td>2</td>
                   
                          <td>Equipment must comply with environmental regulations.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Efficiency Testing</td>
                          <td>Performance Testing</td>
                          <td>Performance Check</td>
                          <td>Custom</td>
                          <td>5</td>
                   
                          <td>Efficiency should meet or exceed specified standards.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Load Testing</td>
                          <td>Performance Testing</td>
                          <td>Performance Check</td>
                          <td>Custom</td>
                          <td>4</td>
                   
                          <td>Equipment should handle specified loads without issues.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Durability Testing</td>
                          <td>Performance Testing</td>
                          <td>Performance Check</td>
                          <td>Custom</td>
                          <td>10</td>
                   
                          <td>Equipment should show minimal wear and tear.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Maintenance Schedule</td>
                          <td>Operational Performance</td>
                          <td>Operational Efficiency</td>
                          <td>Custom</td>
                          <td>10</td>
                   
                          <td>Maintenance schedule should ensure long-term reliability</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Performance Monitoring</td>
                          <td>Operational Performance</td>
                          <td>Performance Check</td>
                          <td>Custom</td>
                          <td>10</td>
                   
                          <td>Performance monitoring should be accurate and reliable.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Downtime Analysis</td>
                          <td>Operational Performance</td>
                          <td>Operational Efficiency</td>
                          <td>Custom</td>
                          <td>10</td>
                   
                          <td>Downtime should be minimal and causes</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr>
                          <tr>
                        <td style={{width: "max-content"}}>Run-Out Testing</td>
                          <td>Performance Testing</td>
                          <td>Performance Check</td>
                          <td>Custom</td>
                          <td>10</td>
                   
                          <td>Equipment should show minimal wear and tear.</td>
                          <td>
                            <button className="btn-btn-udate_boq-div_upload">Upload</button> 
                          </td>
                          <td>
                            <select class="form-select approve_reject_checklist_select1">
                            <option value="selected">Selected</option>
                            <option value="">Approved</option>
                            <option value="">Rejected</option>
                            </select>
                            </td>
                          <td><input type="text" class="form-control from-has_select_checklist "/></td>
                          </tr> 
                        </tbody>
                        </table>
                        </div>
                           }
                          
                <div class="reqc_btns_remarks">
                  <button onClick={() => setOpenApproveQcModalRemarks(false)} class="view_failed">Cancel</button>
                  <button onClick={() => setOpenApproveQcModalRemarks(false)} class="view_success" >Submit</button>
                  </div>
                  </form>
                </div>
              </Box>
            </Modal>
                       ) : null} */}

        </div>

      </div>

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default QcListing;
